import { Link } from 'react-router-dom'
import { useLicense } from '@/hooks/useLicense'
import { ChevronRight } from 'lucide-react'
import { DOCS_URL } from '@/lib/constants'
import {
  OnboardingChecklist as SharedOnboardingChecklist,
  type ChecklistItemData,
} from '@theseus/shared-ui/account'

export function OnboardingChecklist() {
  const { activatedDevices } = useLicense()

  const items: ChecklistItemData[] = [
    {
      id: 'account',
      label: 'Create your account',
      completed: true, // Always true if they're viewing this
    },
    {
      id: 'download',
      label: 'Download Vozilla',
      completed: false, // We can't easily track this
      to: '/downloads',
    },
    {
      id: 'device',
      label: 'Install Cyclops on your drone',
      completed: activatedDevices > 0,
      href: DOCS_URL,
      external: true,
    },
  ]

  const completedCount = items.filter((i) => i.completed).length
  const allCompleted = completedCount === items.length

  if (allCompleted) {
    return null
  }

  return (
    <SharedOnboardingChecklist
      items={items}
      title="Getting Started"
      subtitle="Complete these steps to start using Theseus"
      renderLink={(item, children) => {
        if (item.to && !item.completed) {
          return (
            <Link to={item.to} className="block">
              <div className="relative">
                {children}
                <ChevronRight className="h-3 w-3 text-muted-foreground absolute right-2 top-1/2 -translate-y-1/2" />
              </div>
            </Link>
          )
        }
        if (item.href && !item.completed) {
          return (
            <a
              href={item.href}
              target={item.external ? '_blank' : undefined}
              rel={item.external ? 'noopener noreferrer' : undefined}
              className="block"
            >
              {children}
            </a>
          )
        }
        return <>{children}</>
      }}
    />
  )
}
